import { Title } from '@mantine/core';
import Breadcrumbs, { BreadcrumbItem } from 'components/BreadcrumbsComponent';
import ModuleManagementForm from 'components/forms/dacum/ModuleManagementForm';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { pathnames } from 'routes/dacum';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { moduleManagementService } from 'services/dacum/module.service';
import { showSuccessNotification, showErrorNotification } from 'utils/notification';
import { useModuleManagementStore } from 'store/moduleManagement';
import { FormDataCreateCompetencyModule } from 'types/dacum/moduleManagement';

const AddModuleManagementPage = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { setMode } = useModuleManagementStore();

  React.useEffect(() => {
    setMode('add');
  }, [setMode]);

  const breadcrumbs = [
    { title: 'Competency Module Management', href: pathnames.competencyModule },
    { title: 'New Module', href: '' }
  ];

  const createModule = useMutation({
    mutationFn: (data: FormDataCreateCompetencyModule) =>
      moduleManagementService.createModule(data),
    onSuccess: () => {
      showSuccessNotification({
        title: 'Module Created',
        message: 'Module has been created successfully.'
      });
      queryClient.invalidateQueries({ queryKey: ['moduleCompetency'] });
      navigate(pathnames.competencyModule);
    },
    onError: (error) => {
      showErrorNotification({
        title: 'Failed to create module',
        message: error.message || 'Failed to create module, please try again later.'
      });
    }
  });

  const updateModule = useMutation({
    mutationFn: (data: FormDataCreateCompetencyModule) => {
      // This won't be used in add mode, but required by the form component
      return moduleManagementService.updateModule({ ...data, trCompetencyModuleID: '' });
    },
    onSuccess: () => {
      // This won't be called in add mode
    },
    onError: () => {
      // This won't be called in add mode
    }
  });

  return (
    <>
      <Breadcrumbs items={breadcrumbs as BreadcrumbItem[]} mb={32} />
      <Title order={2} mb={30}>
        Create New Module
      </Title>
      <ModuleManagementForm createModule={createModule} updateModule={updateModule} />
    </>
  );
};

export default AddModuleManagementPage;
